export default __webpack_public_path__ + "static/media/full1.145e50cc.jpg";